/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {ReactNode} from 'react';
import {WithTranslationProps} from 'react-i18next';
import IonContent from '@ion/dls/src/components/grid/IonContent';
import {GridLayoutSizes} from '@ion/dls/src/types/components';

// defines the props used by the local content component ...
export interface LayoutContentProps extends WithTranslationProps {
  initialized?: boolean;
  children?: ReactNode;
  grid?: boolean;
  backgroundColor?: string;
  id?: string;
  omit?: boolean;
  title?: string;
  gridLayoutSizes?: GridLayoutSizes;
}

/**
 * Defines the Content Wrapper Component which manages the rendering of the
 * content area of the Layout based on the initialization state and provided
 * props.
 *
 * ```typescript
 *
 *   import LayoutContent, {LayoutContentProps} from '@ion/applications/src/layout/LayoutContent';
 *   ...
 *   <LayoutContent initialized={pageInitialized} grid={grid}>
 *     {children}
 *   </LayoutContent>
 *
 * ```
 */
export const LayoutContent = ({
  initialized,
  gridLayoutSizes,
  children,
  grid = true,
  id = 'layout-content'
}: LayoutContentProps) => {
  if (initialized) {
    if (grid) {
      return (
        <div id={id}>
          <IonContent gridLayoutSizes={gridLayoutSizes}>{children}</IonContent>
        </div>
      );
    }
    return <>{children}</>;
  }
  return null;
};
export default LayoutContent;
